// extracted by mini-css-extract-plugin
export default {"input":"styles_input__JBj4X","desc":"styles_desc__miQow"};